/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieGridItemViewModel } from "../types/SerieGridItemViewModel.ts";

export const serieGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da série.")),
  thumbnail: z
    .string()
    .describe("Caminho da imagem de capa (thumbnail) no storage. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se a série está ativa.")),
  isGeneral: z.optional(
    z
      .boolean()
      .describe("Indica se a série é geral (disponível a todas as turmas)."),
  ),
  langName: z
    .string()
    .describe("Título da série no idioma corrente (ou o primeiro disponível).")
    .nullish(),
}) as unknown as ToZod<SerieGridItemViewModel>;
